<template>
  <div class="bind-job">
    <el-dialog :visible="bindJobShow" width="720px" @close="dialogClose" @open="dialogOpen">
      <div class="title" slog="title">
        <span>{{ checkInfo.checkName }}</span>
        <i class="icon el-icon-circle-plus-outline" @click="addJob"></i>
        <i class="icon el-icon-remove-outline" @click="delJob"></i>
      </div>
      <div class="bind-dialog">
        <el-form
          v-for="(item, index) in bindList"
          :key="index"
          :inline="true"
          :model="item"
          class="demo-form-inline"
        >
          <el-form-item label="职务">
            <el-select v-model="item.jobId" placeholder="请选择" style="width: 120px;">
              <el-option
                v-for="item in jobList"
                :key="item.id"
                :label="item.jobName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核顺序" style="margin-left: 30px;">
            <el-input
              v-model.number="item.rank"
              placeholder="请输入"
              prop="rank"
              type="number"
              :min="1"
              style="width: 120px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="请假天数" style="margin-left: 30px;" v-if="checkInfo.checkCode == 'LEAVE_REVIEW'">
            <el-input
              v-model.number="item.checkRule"
              placeholder="请输入"
              prop="checkRule"
              type="number"
              :min="1"
              style="width: 120px;"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btns">
        <!-- <div class="btn define" @click="addJob">添加</div> -->
        <div class="btn define" @click="confirm">确定</div>
        <div class="btn cancel" @click="dialogClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["bindJobShow", "checkInfo"],
  data() {
    return {
      jobList: [],
      bindList: [
        {
          rank: "",
          jobId: "",
          checkRule: "",
          checkId: this.checkInfo.id,
        },
      ],
    };
  },
  inject: ["refresh"],
  created() {
    this.getSchoolJobList();
    this.getSchoolCheckListBind();
  },
  methods: {
    getSchoolCheckListBind() {
      this.get(this.$url.getSchoolCheckListBind + "?checkId=" + this.checkInfo.id).then(
        (res) => {
          // console.log("查看审核类型与职务绑定==>", res);
          if (res.code == 200 && res.data != "") {
            this.bindList = res.data;
          }
        }
      );
    },
    confirm() {
      const hasIncompleteInfo = this.bindList.some((item) => {
        return item.rank === "" || item.job === "";
      });

      if (hasIncompleteInfo) {
        this.$message.warning("请补充完整信息！");
        return; // 停止后续代码执行
      }

      // console.log(this.bindList);
      this.post(this.$url.insertJobCheckBath, this.bindList).then((res) => {
        if (res.code == 200) {
          this.$message.success("添加绑定成功");
          this.dialogClose();
          // 刷新列表
          this.refresh();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    addJob() {
      this.bindList.push({
        rank: "",
        jobId: "",
        checkRule: "",
        checkId: this.checkInfo.id,
      });
    },
    delJob() {
      if (this.bindList.length == 1) return this.$message.warning("至少存在一条数据！");
      this.bindList.pop();
    },
    getSchoolJobList() {
      this.get(this.$url.getSchoolEditJobList + "?schoolId=" + this.user.schoolId).then(
        (res) => {
          // console.log(res);
          this.jobList = res.rows;
        }
      );
    },
    dialogClose() {
      this.$emit("update:bindJobShow", false);
    },
    dialogOpen() {
      this.bindList = [
        {
          rank: "",
          job: "",
          checkRule: "",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./bind-job.scss";
</style>
